export const manageCatgoryConstants = {
	ManageCategoryGetByfilterRequest: "MANAGE_CATEGORY_GET_BY_FILTER_STARTED",
	ManageCategoryGetByfilterSuccess: "MANAGE_CATEGORY_GET_BY_FILTER_COMPLETED",
	ManageCategoryGetByfilterFailure: "MANAGE_CATEGORY_GET_BY_FILTER_FAILED",

    ManageCategoryUpdateStatusRequest: "MANAGE_CATEGORY_UPDATE_STATUS_STARTED",
	ManageCategoryUpdateStatusSuccess: "MANAGE_CATEGORY_UPDATE_STATUS_COMPLETED",
	ManageCategoryUpdateStatusFailure: "MANAGE_CATEGORY_UPDATE_STATUS_FAILED",

    ManageCategoryCreateRequest: "MANAGE_CATEGORY_CREATE_STARTED",
	ManageCategoryCreateSuccess: "MANAGE_CATEGORY_CREATE_COMPLETED",
	ManageCategoryCreateFailure: "MANAGE_CATEGORY_CREATE_FAILED",

	ManageCategoryUpdateRequest: "MANAGE_CATEGORY_UPDATE_STARTED",
	ManageCategoryUpdateSuccess: "MANAGE_CATEGORY_UPDATE_COMPLETED",
	ManageCategoryUpdateFailure: "MANAGE_CATEGORY_UPDATE_FAILED",

	ManageCategoryDeleteRequest: "MANAGE_CATEGORY_DELETE_STARTED",
	ManageCategoryDeleteSuccess: "MANAGE_CATEGORY_DELETE_COMPLETED",
	ManageCategoryDeleteFailure: "MANAGE_CATEGORY_DELETE_FAILED",
};
